import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { ChevronDown } from 'lucide-react';

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  cursor: pointer;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #2d2d2d;
  transition: all 0.2s ease;
  min-width: 160px;

  &:hover {
    border-color: #D2691E;
    box-shadow: 0 4px 8px rgba(210, 105, 30, 0.15);
    background-color: #FFF8F2;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  min-width: 200px;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(210, 105, 30, 0.12);
  overflow: hidden;
  margin-top: 8px;
`;

const MenuItem = styled.button`
  width: 100%;
  padding: 14px 18px;
  background-color: #ffffff;
  border: none;
  border-bottom: 1px solid #f8f8f8;
  text-align: left;
  cursor: pointer;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #2d2d2d;
  transition: all 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #FFF8F2;
    color: #D2691E;
  }

  &.active {
    background-color: #D2691E;
    color: #ffffff;
    font-weight: 500;
  }
`;

const SortDropdown = ({ options, value, onChange, label = "정렬" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption = options.find(option => option.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownButton onClick={() => setIsOpen(!isOpen)}>
        <span>{selectedOption ? selectedOption.label : label}</span>
        <ChevronDown size={16} style={{ transform: isOpen ? 'rotate(180deg)' : 'none' }} />
      </DropdownButton>
      
      {isOpen && (
        <DropdownMenu>
          {options.map((option) => (
            <MenuItem
              key={option.value}
              className={option.value === value ? 'active' : ''}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </MenuItem>
          ))}
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};

export default SortDropdown;
